import React from "react";
import { AdminAppConfig } from "oneclick-component/src/store/apis/enhancedApi";

export interface FeatureConfigContextValue extends AdminAppConfig {}

export const FeatureConfigContext =
  React.createContext<FeatureConfigContextValue>(null as any);
